// extracted by mini-css-extract-plugin
module.exports = {"tabContent":"ruZ86Nh3","wrapper":"izK2e5H3","tableWrapper":"ULKrLn_i","tableLoaderWrapper":"cQdmWe2i","assetCell":"Azd_BG1k","cellWithChartContainer":"bqu9zCdX"};